module.exports = __webpack_public_path__ + "img/fig02.6f0c3c8e.jpg";